import React from 'react';
import { unitsTypes } from '../../../constants/dashboards';
import EventPreview from './EventPreview';
import RetentionPreview from './RetentionPreview';
import UserPreview from './UserPreview';
import RevenuePreview from './RevenuePreview';
import RetentionSimplePreview from './RetentionSimplePreview';
import FunnelPreview from './FunnelsPreview';

const ResultPreview = (props) => {
  const { unit } = props;
  switch (unit.type) {
    case unitsTypes.EVENTS_TYPE:
      return <EventPreview {...props} />;
    case unitsTypes.RETENTION_TYPE:
      return <RetentionSimplePreview {...props} />;
    case unitsTypes.RETENTION_COMPLEX_TYPE:
      return <RetentionPreview {...props} />;
    case unitsTypes.USERS_TYPE:
      return <UserPreview {...props} />;
    case unitsTypes.REVENUE_TYPE:
      return <RevenuePreview {...props} />;
    case unitsTypes.FUNNELS_TYPE:
      return <FunnelPreview {...props} />;
    default:
      return undefined;
  }
};

export default ResultPreview;
